import { tickerConstants } from '../actionTypes';
import { userService } from '../middlewares/userService';

export const tickerActions = {
    getTickerNews,
    onSetTickerOpen
};

function getTickerNews() {
    return dispatch => {
        dispatch(request());
        userService.getTickerNews()
            .then(
                response => {
                    if(response === undefined)
                    {
                        dispatch(failure('No newtwork connection found. Unable to load ticker.'));
                    }else{
                        const resp = response?.data;
                        const responseData = resp?.data;
                        dispatch(success(responseData?.results));
                    }
                }
            )
            .catch(error => {
                dispatch(failure(error.toString()));
            });
    };

    function request() { return { type: tickerConstants.TICKER_REQUEST } }
    function success(user) { return { type: tickerConstants.TICKER_SUCCESS, user } }
    function failure(error) { return { type: tickerConstants.TICKER_FAILURE, error } }
}

function onSetTickerOpen(sidebarOpen){
    return dispatch => {
        dispatch(setSideBar(sidebarOpen));
    };
    function setSideBar(response) { return { type: tickerConstants.SET_SIDEBAR, response } }
}